// Maps the opaque backend error codes (ssoSamlController.js's errorRedirect()) to readable text.
// Reached only via SsoCallback.jsx, since the IdP posts straight to the backend's ACS endpoint —
// there's no SSO UI on /login itself to redirect through instead (KAN-143: IdP-initiated only).
export const SSO_ERROR_MESSAGES = {
  sso_tenant_inactive: "Your organization's account is inactive. Contact support.",
  sso_not_configured: "SSO isn't fully configured for your organization yet. Contact your admin.",
  sso_missing_claims: "Your identity provider didn't return an email address.",
  sso_domain_blocked: "Please use a business email address. Personal email providers are not accepted.",
  sso_account_disabled: "This account has been disabled. Contact your administrator.",
  sso_callback_failed: "Sign-in failed. Please try again.",
};

export function ssoErrorMessage(code) {
  return SSO_ERROR_MESSAGES[code] || "Sign-in failed. Please try again.";
}
